import { createFileRoute } from '@tanstack/react-router';
import { S9Search } from '@/screens/S9Search/S9Search';

type SearchSearch = {
  q?: string;
};

export const Route = createFileRoute('/$orgId/search')({
  validateSearch: (raw: Record<string, unknown>): SearchSearch => ({
    q: typeof raw.q === 'string' && raw.q ? raw.q : undefined,
  }),
  component: S9Search,
});
